export default __webpack_public_path__ + "static/media/About_BG-09.1a8fb04c.svg";